<template>
  <div>
    <EditForm
      ref="editForm"
      :disabled="isDisableEditForm"
      :evgPackingSchemeCode="params.code"
    />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-evgBiz-evgPackagingScheme-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
}
</script>
